import useOptions from 'app/hooks/useOptions'
import { getSubCategories } from 'app/services/Api/listing'

interface UseSubCategoryOptionsProps {
  categoryId?: string
  categoryName?: string
  subCategoryId?: string
  loadResponse?: (res: Category[]) => void
}

const useSubCategoryOptions = ({
  categoryId,
  categoryName,
  subCategoryId,
  loadResponse
}: UseSubCategoryOptionsProps) => {
  const key = categoryId || categoryName

  const { options: subCategoryOptions } = useOptions({
    key: [key],
    enabled: !!key,
    loadOptions: async () => {
      const res = await getSubCategories({
        ...(categoryId && { by_category_id: categoryId }),
        ...(categoryName && { by_category_name: categoryName })
      })

      if (loadResponse) loadResponse(res)

      return res
    }
  })
  const selectedSubCategory = subCategoryOptions?.find(
    ({ value }) => value === subCategoryId
  ) as SubCategory | undefined

  const isAttributionsPresent = !!selectedSubCategory?.attributions_present
  const selectedSubCategoryHSCode =
    selectedSubCategory?.harmonized_tariff_code ?? ''
  const isDangerSubcategory = !!selectedSubCategory?.danger
  const hasSelectedSubCategory = !!selectedSubCategory?.parent?.id

  return {
    subCategoryOptions,
    isAttributionsPresent,
    selectedSubCategoryHSCode,
    isDangerSubcategory,
    hasSelectedSubCategory
  }
}

export default useSubCategoryOptions
